import { useEffect, useState } from "react";
import { DateRange } from "react-date-range";
import { ChevronDown } from "lucide-react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

export default function DateRangePickerComponent({ onApply, fetchSummaryData }) {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedRange, setSelectedRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  const [lastCommitted, setLastCommitted] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });


  useEffect(() => {
    const updateSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleApply = () => {
    setLastCommitted({ ...selectedRange });
    setOpen(false);
    onApply(
      selectedRange.startDate.toLocaleDateString("en-CA"),
      selectedRange.endDate.toLocaleDateString("en-CA"),
    );
  };

  const handleReset = () => {
    const today = new Date();
    const resetRange = {
      startDate: today,
      endDate: today,
      key: "selection",
    };
    setSelectedRange(resetRange);
    setLastCommitted(resetRange);
    fetchSummaryData();
    setOpen(false);
  };

  const handleCancel = () => {
    setSelectedRange({ ...lastCommitted, key: "selection" });
    setOpen(false);
  };

  return (
    <div className="relative inline-block">
      <button
        onClick={() => setOpen(true)}
        className="flex items-center px-4 py-2 border rounded bg-white shadow-lg text-gray-600"
      >
        Select Date Range
        <ChevronDown size={18} className="ml-2 text-gray-600" />
      </button>

      {open && (
        <div
          className="absolute z-50 mt-2 bg-white p-4 rounded-xl shadow-xl border w-fit max-w-[95vw]
          right-5 -top-40"
        >
          <DateRange
            editableDateInputs={true}
            onChange={(ranges) => setSelectedRange(ranges.selection)}
            moveRangeOnFirstSelection={false}
            ranges={[selectedRange]}
            months={2}
            className="w-full"
            direction={isMobile ? "vertical" : "horizontal"}
          />
          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={handleCancel}
              className="text-sm text-gray-600 px-4 py-2 border rounded hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              onClick={handleReset}
              className="text-sm px-4 py-2 bg-gray-100 border border-gray-300 rounded hover:bg-gray-200 text-gray-800"
            >
              Reset
            </button>
            <button
              onClick={handleApply}
              className="text-sm px-4 py-2 bg-primary-600 text-white rounded hover:opacity-90"
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
}